module.exports = [
    { "name": "English", "code": "en" },
    { "name": "Hindi", "code": "hi" },
    { "name": "Indonesian", "code": "id" },
    { "name": "Spanish", "code": "es" },
    { "name": "French", "code": "fr" },
    { "name": "German", "code": "de" },
    { "name": "Chinese", "code": "zh" },
    { "name": "Vietnamese", "code": "vi" },
    { "name": "Thai", "code": "th" },
    { "name": "Japanese", "code": "ja" },
    { "name": "Chinese (Traditional)", "code": "hk" },
    { "name": "Tagalog (Filipino)", "code": "tl" },
    { "name": "Afrikaans", "code": "af" },
    { "name": "Korean", "code": "ko" },
    { "name": "Maori", "code": "mi" },
    { "name": "Arabic", "code": "ar" },
    { "name": "Russian", "code": "ru" },
    { "name": "Finnish", "code": "fi" },
    { "name": "Portuguese", "code": "pt" }
]